import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsTabComponent } from "./ds-tab.component";

@NgModule({
  declarations: [DsTabComponent],
  imports: [CommonModule],
  exports: [DsTabComponent],
})
export class DsTabModule {}
